<template>
  <div class="px-3">
    <tabs fill info type="info" tabNavClasses="tabList col-4" tabContentClasses="" activeTab="tab360ModelSection">
      <card shadow bodyClasses="frameContainerClass">
        <tabPane title="360 Photo Model" id="tab360ModelSection">
          <div class="description">
            <vue-friendly-iframe v-if="activeTabFlags.tab360ModelSection" src="https://360-images.geodemosolutions.com/" className="myFrame" allow="*"></vue-friendly-iframe>
          </div>
        </tabPane>
        <tabPane title="PC Station Building" id="pointCloudBuilding" >
          <div class="description">
            <vue-friendly-iframe v-if="activeTabFlags.pointCloudBuilding" src="https://recap.autodesk.com/project/c61c4b8d7b34465d89fbca0d467343b0" className="myFrame" allow="*"></vue-friendly-iframe>
            <!-- <img src="img/assets/BIM_360_Document_Management.png" alt="" class="myFrame"> -->

            <!-- do not remove the IFRAME below, as we'll replace this with the proper link on prod -->
            <!-- <vue-friendly-iframe v-if="activeTabFlags.bim360Section" src="https://docs.b360.autodesk.com/projects/3f5bc2e8-a49b-4dda-a2be-9cd7018286fb/folders/urn:adsk.wipprod:fs.folder:co.6qt7XpECQLuyyPmcVZzDLQ/detail" className="myFrame" allow="*"></vue-friendly-iframe> -->
          </div>
        </tabPane>
        <tabPane title="PC Station Precinct" id="pointCloudPrecinct" >
          <div class="description">
            <vue-friendly-iframe v-if="activeTabFlags.pointCloudPrecinct" src="https://recap360.autodesk.com/project/d2bd20b8f8b54b60838c7b6d60caf141" className="myFrame" allow="*"></vue-friendly-iframe>
            <!-- <img src="img/assets/BIM_360_Document_Management.png" alt="" class="myFrame"> -->

            <!-- do not remove the IFRAME below, as we'll replace this with the proper link on prod -->
            <!-- <vue-friendly-iframe v-if="activeTabFlags.bim360Section" src="https://docs.b360.autodesk.com/projects/3f5bc2e8-a49b-4dda-a2be-9cd7018286fb/folders/urn:adsk.wipprod:fs.folder:co.6qt7XpECQLuyyPmcVZzDLQ/detail" className="myFrame" allow="*"></vue-friendly-iframe> -->
          </div>
        </tabPane>
      </card>
    </tabs>
  </div>

</template>

<script>
// import VueFrame from 'vue-frame'
import tabs from '../components/Tabs/Tabs.vue';
import tabPane from  '../components/Tabs/TabPane.vue';
export default {
  name: 'LandingPage',
  components: {
    // VueFrame
    tabs,
    tabPane
  },
  data() {
    return {
      links: {
        collab: ""
      },
    }
  },
  computed: {
    activeTabFlags: {
        get() {
          return this.$store.state.sideBarStore.activeTabFlags
        }
      }
  }
}
</script>

<style >
.myFrame {
  /* width: 1473px!important; */
  width: 1873px!important;
  height: 763px!important;
  border: none;
}
.frameContainerClass {
  padding:3px!important;
  border-color: #404952;
  border-style: solid;
}

</style>
